import { CartItemDesign } from "../models/CartItem";
import { DesignLogo } from "../../../../core/models/entities/Design";
import { useAddLogoToOrderDialog } from "../../../components/Dialogs/add-logo-to-design-order-dialog";
import { DesignPrintItem } from "./DesignPrintItem";
import { getColorsElements } from "./ProductDetailsLogo";

interface OrderLineViewDesignPrintProps {
  orderline: CartItemDesign;
  designLogo: DesignLogo;
}

export function OrderLineViewDesignPrint({
  orderline,
  designLogo,
}: OrderLineViewDesignPrintProps) {
  const views = orderline.design.style?.styleViews ?? [];
  const relevantViews = views.filter((v) => v.id == designLogo.viewId);
  const placements = relevantViews.map((x) => x.view).join("");

  const { component, open } = useAddLogoToOrderDialog(designLogo);

  return (
    <>
      {component}
      <DesignPrintItem
        logo={designLogo.logo}
        addMoreAction={open}
        placements={placements}
        colors={getColorsElements(designLogo.logo)}
      />
    </>
  );
}
